import React from 'react';
import { cn } from '../lib/utils';

export interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {}

/** Categories share badge geometry and use a neutral fill without a status dot. */
export function Tag({ children, className, ...props }: TagProps) {
  return (
    <span
      {...props}
      data-ui="tag"
      className={cn(
        'inline-flex w-auto self-start justify-self-start max-w-full shrink-0 whitespace-nowrap items-center rounded-badge border border-transparent bg-status-neutral-bg px-2 py-0.5 font-body text-caption font-medium text-text-body',
        className,
      )}
    >
      {children}
    </span>
  );
}
